module.exports = __webpack_public_path__ + "img/thumbnail_BorneanOrangutan_j_albino.a06ab8c0.png";